import { render, staticRenderFns } from "./showDetails.vue?vue&type=template&id=7dce45e8&scoped=true"
import script from "./showDetails.vue?vue&type=script&lang=js"
export * from "./showDetails.vue?vue&type=script&lang=js"
import style0 from "./showDetails.vue?vue&type=style&index=0&id=7dce45e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dce45e8",
  null
  
)

export default component.exports